export const TAGGING_ERRORS={
    "DEFAULT_TEXT":"Enter text followed by space to add tag",
    "MAX_LIMIT_REACHED":"Max limit reached for adding tags on the file",
    "INVALID_TAG":"Tag cannot have special characters",
    "ALPHA_NUMERIC_ERROR":"Tag must be alpha numeric",
    "MIN_LENGTH_ERROR":"Minimum length should be  3 characters",
    "TAG_ALREADY_EXISTS":" tag already exists for this file",
    "NMSOM0138":"Max limit reached for adding tags on the file",
    "TAGS_ADDED_MSG":"Tag(s) added successfully",
    "TAGS_REMOVED_MSG":"Tag(s) removed successfully",
    "TAGS_UPDATED_MSG":"Tag(s) updated successfully",
    "UPDATING_SERVER_ERROR":"We could not save your hashtags, please try again later",
    "SERVER_ERROR":"Could not fetch tags, something went wrong! Please try again later",
    "FIRST_CHARACTER_ERROR":"Tag can't start with numbers.",
    "NO_INTERNET_MSG":"File tagging need internet connection",
    "BLUR_EVENT_ERROR":"Hit Space/Enter to add the tag",
    "LENGTH_ERROR":"Tag can't have more than 30 characters",
}